// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<{ index: number; product: ProductModel }>;

export const DispatchSetSelectedVideoIndex: HandlerType = (props) => {
    props.dispatch({
        type: "xProductDetails/SetSelectedVideoIndex",
        index: props.parameter.index,
        product: props.parameter.product,
    } as any);
};

export const chain = [DispatchSetSelectedVideoIndex];

const setSelectedVideoIndex = createHandlerChainRunner(chain, "SetSelectedVideoIndex");
export default setSelectedVideoIndex;
